module.exports = __webpack_public_path__ + "static/img/factory-cart_256.621a73d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/factory-cart_256.png
// module id = 9coI
// module chunks = 0